module.exports = __webpack_public_path__ + "img/carclub-selected.52ac4f92.svg";